import { render, staticRenderFns } from "./bukubesar.vue?vue&type=template&id=9c84e350&scoped=true"
import script from "./bukubesar.vue?vue&type=script&lang=js"
export * from "./bukubesar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c84e350",
  null
  
)

export default component.exports